import React from "react";

export default function TextSection(props) {
  return (
    <h1 id={props.id} className={" text-section " + props.class} style={props.style}>
      <span className={`animate__animated  ${props.animation ? props.animation : "animate__fadeInDown"} `}>
        {props.text}
      </span>
    </h1>
  );
}
